import { useState } from 'react'
// Components
import styles from './Subscribe.module.scss'

export default function Subscribe () {
  const [email, setEmail] = useState('')
  const [hasSubscribed, setHasSubscribed] = useState(false)

  if (hasSubscribed) {
    return (
      <div className={styles.subscribe}>
        <div className={styles.bubble} />

        <h2>Thanks for signing up!</h2>

        <p>
          Keep an eye on your email. We’ve got lots of amazing things coming your way!
        </p>
      </div>
    )
  }

  const onSubmit = (e) => {
    e?.preventDefault()

    if (email && window?._learnq) {
      window._learnq.push(['identify', {
        $email: email,
        $source: 'Blog subscriber'
      }])

      setHasSubscribed(true)
    }
  }

  return (
    <div className={styles.subscribe}>
      <h2>Join the pack!</h2>

      <p>
        Sign up and stay up to date with lovely pups, deals, new articles, and more!
      </p>

      <form onSubmit={onSubmit}>
        <input
          type='email'
          placeholder='Enter email address'
          autoComplete='off'
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <div className={styles.icon} onClick={onSubmit} />
      </form>
    </div>
  )
}
